import React, { useEffect, useState } from 'react';
import firebase, { firebaseAnalytics } from './Firebase';
import Recensione from "./Recensione"
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Spinner, Dropdown, Form } from 'react-bootstrap';

export default function Ranking() {
    const [totRev, setTotRev] = useState([]);
    const [aziende, setAziende ] = useState({});
    const [reviewsERBA, setReviewsERBA] = useState([]);
    const [reviewsHASH, setReviewsHASH] = useState([]);
    const [reviewsHashNoTerps, setReviewsHashNoTerps] = useState([]);
    const [terpenati, setTerpenati] = useState(true);
    const [year, setYear] = useState("2022")
    const [year2, setYear2] = useState("2022")
    var position = 1

    var y = "2022"
    var y2 = "2022"

    const ref = firebase.firestore().collection('recensioni')
    const refAz = firebase.firestore().collection('aziende')

    useEffect(() => {
        firebaseAnalytics.logEvent("rankings_tab_visited");
        refAz.onSnapshot((query) => {
            updateAziende(query)}
            )
        ref.onSnapshot((query)  => {
            updateState(query)}
            );
    }, []);

    const updateState = query => {
        var items = [];
        query.forEach(doc => items.push(doc.data()));
        setTotRev(items);
        switchYearERBA(items, y)
        switchYearHASH(items, y2)
    }

    const updateAziende = query => {
        var items = {}
        query.forEach(item => {
            items[item.data().nome] = item.data()
        })
        setAziende(items)
    }

    const switchYearERBA = (list, filter) => {
        var items = list
        switch (filter) {
            case "2020":
                items =
                    list    
                    .filter(review => review.tipo === "Erba")
                    .filter(r => r.data.seconds <1609455600) // 01/01/2021
                    .filter(r => r.data.seconds >1577836801) // 01/01/2020
                    .sort(function compareNumbers(a, b) {
                        return ((b.aspetto + b.fumata + b.odore + b.svapata) - (a.aspetto + a.fumata + a.odore + a.svapata)) / 4;
                        })
                break;
    
            case "2021":
                items =
                    list
                    .filter(review => review.tipo === "Erba")
                    .filter(r => r.data.seconds <1640991600) // 01/01/2022
                    .filter(r => r.data.seconds >1609455600) // 01/01/2021
                    .sort(function compareNumbers(a, b) {
                        return ((b.aspetto + b.fumata + b.odore + b.svapata) - (a.aspetto + a.fumata + a.odore + a.svapata)) / 4;
                        })
                break; 

            case "2022":
                items = 
                    list
                    .filter(review => review.tipo === "Erba")
                    .filter(r => r.data.seconds >1640991600) // 01/01/2022
                    .sort(function compareNumbers(a, b) {
                        return ((b.aspetto + b.fumata + b.odore + b.svapata) - (a.aspetto + a.fumata + a.odore + a.svapata)) / 4;
                        })
            break;

            case "Di sempre":
                items =
                    list
                    .filter(review => review.tipo === "Erba")
                    .sort(function compareNumbers(a, b) {
                        return ((b.aspetto + b.fumata + b.odore + b.svapata) - (a.aspetto + a.fumata + a.odore + a.svapata)) / 4;
                        })
                break;
        }
        setReviewsERBA(items);
    }

    const switchYearHASH = (list, filter ) => {
        var items = list

        switch (filter) {
            case "2020":
                items =
                    list
                    .filter(review => review.tipo === "Hash")
                    .filter(r => r.data.seconds <1609455600) // 01/01/2021
                    .filter(r => r.data.seconds >1577836801) // 01/01/2020
                    .sort(function compareNumbers(a, b) {
                        return ((b.aspetto + b.fumata) - (a.aspetto + a.fumata )) / 2;
                    })
                break;

            case "2021":
                items =
                    list
                    .filter(review => review.tipo === "Hash")
                    .filter(r => r.data.seconds <1640991600) // 01/01/2022
                    .filter(r => r.data.seconds >1609455600) // 01/01/2021 
                    .sort(function compareNumbers(a, b) {
                    return ((b.aspetto + b.fumata) - (a.aspetto + a.fumata)) / 2;
                    })
                break;

            case "2022":
                items =
                    list
                    .filter(review => review.tipo === "Hash")
                    .filter(r => r.data.seconds >1640991600) // 01/01/2021
                    .sort(function compareNumbers(a, b) {
                    return ((b.aspetto + b.fumata) - (a.aspetto + a.fumata)) / 2;
                    })
                break;

            case "Di sempre":
                items =
                    list
                    .filter(review => review.tipo === "Hash")
                    .sort(function compareNumbers(a, b) {
                    return ((b.aspetto + b.fumata) - (a.aspetto + a.fumata)) / 2;
                    })
                break;
        }
        setReviewsHASH(items);
        setReviewsHashNoTerps(items.filter( r => !r.terpenato))
    }

    const renderRows = recensione => {
        return <Recensione review={recensione} az={aziende[recensione.marca]} type={"row"} position={position++}/>
    }

    return (
        <>
            {aziende === {} ? 
            <h2 style={{ color: 'white' }}>
                <Spinner animation="grow" />
            </h2>
            : 
            (
                <div class="row" style={{justifyContent: "space-evenly"}}>
                {/* classifica ERBE */}
                <div style={{marginInline: "20px"}}>
                    <div class="row titolo_tabella" >
                        <h3 style={{ color: 'white', paddingRight: "2%", marginBottom: "0px", }}>Top 15 🍁 </h3>
                        <Dropdown className='input-varieta' >
                            <Dropdown.Toggle id="dropdown-basic" variant='secondary' style={{ backgroundColor: "#2c2c32", boxShadow: 'none', fontWeight:"500" }}>{year}</Dropdown.Toggle>
                            <Dropdown.Menu>
                            <Dropdown.Item onClick={() => {setYear("2022"); y = "2022"; switchYearERBA(totRev, "2022")}}>2022</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={() => {setYear("2021"); y = "2021";switchYearERBA(totRev, "2021")}}>2021</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={() => {setYear("2020"); y = "2020"; switchYearERBA(totRev, "2020")}}>2020</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={() => {setYear("Di sempre"); y = "Di sempre";switchYearERBA(totRev, "Di sempre")}}>Di sempre</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    
                    <br/>
                    <Table striped bordered hover variant="dark" style={{ padding: 0}}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th></th>
                                <th>Brand</th>
                                <th>Nome</th>
                                <th>Voto</th>
                            </tr>
                        </thead>
                        { reviewsERBA.slice(0, 15).map(data => renderRows(data))}
                    </Table>
                </div>
                {/* classifica HASH */}
                <div style={{marginInline: "20px"}}>
                    <div class="row titolo_tabella">
                    <h3 style={{ color: 'white', paddingRight: "2%", marginBottom: "0px", }}>Top 15 🍫 </h3>
                        <Dropdown className='input-varieta' >
                            <Dropdown.Toggle id="dropdown-basic" variant='secondary' style={{ backgroundColor: "#2c2c32", boxShadow: 'none', fontWeight:"500" }}>{year2}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => {setYear2("2022"); switchYearHASH(totRev,"2022" )}}>2022</Dropdown.Item>
                            <Dropdown.Divider />
                                <Dropdown.Item onClick={() => {setYear2("2021");switchYearHASH(totRev, "2021" )}}>2021</Dropdown.Item>
                            <Dropdown.Divider />
                                <Dropdown.Item onClick={() => {setYear2("2020"); switchYearHASH(totRev, "2020")}}>2020</Dropdown.Item>
                            <Dropdown.Divider />
                                <Dropdown.Item onClick={() => {setYear2("Di sempre");switchYearHASH(totRev, "Di sempre")}}>Di sempre</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <Form.Check 
                            style={{color: "white"}}
                            type={"checkbox"}
                            id={1}
                            label={"Includi prodotti terpenati."}
                            checked={terpenati}
                            onChange={() => {setTerpenati(!terpenati)}}
                        />
                    
                    <Table striped bordered hover variant="dark" style={{ padding: 0}}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th></th>
                                <th>Brand</th>
                                <th>Nome</th>
                                <th>Voto</th>
                            </tr>
                        </thead>
                        { position=1, 
                        (terpenati ? 
                            reviewsHASH.slice(0, 15).map(data => renderRows(data))
                            : 
                            reviewsHashNoTerps.slice(0, 15).map(data => renderRows(data))
                        )}
                    </Table>
                </div>
            </div>
             ) }
        </>
    );
}